
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HubSpotScript = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove any existing HubSpot script
    const existingScript = document.getElementById('hs-script-loader');
    if (existingScript) {
      existingScript.remove();
    }

    // Select the right HubSpot ID based on URL
    const hubspotId = location.pathname.includes('demostraciones') 
      ? '47200321' 
      : '22781597';

    // Create and append the new script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${hubspotId}.js`;
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      const scriptToRemove = document.getElementById('hs-script-loader');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname]);

  return null;
};

export default HubSpotScript;
